"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _services = require("../../../services");
var _CustomIconOrImage = _interopRequireDefault(require("../../shared/CustomIconOrImage"));
var _BusinessSolutionAddOnParser = require("../../../utils/parsers/maac/BusinessSolutionAddOnParser");
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BorderWrapper = _styledComponents.default.div`
  border: 1px solid #bebebe;
  border-radius: 12px;
  gap: 10px;
  padding: 20px 10px 20px 10px;
  display: flex;
  flex-direction: column;
  ${_r10SourceLibrary.Mixins.respondTo.md(`padding: 20px 24px 20px 24px;`)}
`;
const ContentBlock = _styledComponents.default.div`
  display: flex;
  flex: 1;
  ${props => {
  switch (props.align) {
    case 'baseline':
      return (0, _styledComponents.css)`
          align-items: baseline;
        `;
    case 'center':
      return (0, _styledComponents.css)`
          align-items: center;
        `;
    default:
      return;
  }
}}
`;
const HeadingBlock = (0, _styledComponents.default)(ContentBlock)`
  padding: 20px 0px;
`;
const PriceBlock = (0, _styledComponents.default)(ContentBlock)`
  padding: 4px 0px 4px 0px;
`;
const BulletBlock = (0, _styledComponents.default)(ContentBlock)`
  gap: 10px;
`;
const RightTextStack = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: end;
  ${_r10SourceLibrary.Mixins.respondTo.md(`
    flex-direction: row;  
    gap: 10px; 
    justify-content: flex-end;
    align-items: start;`)}
`;
const LeftTextStack = _styledComponents.default.div`
  display: flex;
  flex: 1;
`;
const FinePrintBlock = _styledComponents.default.span`
  font-size: 12px;
  line-height: 12px;
  vertical-align: bottom;
`;
const InfoText = _styledComponents.default.span`
  font-weight: ${props => props.isBold && "bold"};
  font-size: 12px;
  line-height: 12px;
  vertical-align: bottom;
  text-align: end;
  ${_r10SourceLibrary.Mixins.respondTo.md(`
text-align: start;`)}
`;
const RightStackFinePrintAlignmentContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  ${_r10SourceLibrary.Mixins.respondTo.md(`margin-top: 9px;`)}
`;
const RecommendationBusinessSolutionAddOn = _ref => {
  let {
    selectedBusinessSolution
  } = _ref;
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const addonCharacteristics = (0, _useConfig.default)('addonCharacteristics', []);
  const {
    name,
    price,
    costInfo,
    characteristics
  } = new _BusinessSolutionAddOnParser.BusinessSolutionAddOnParser(selectedBusinessSolution, addonCharacteristics).AddOnSectionProps;
  return /*#__PURE__*/_react.default.createElement(BorderWrapper, null, /*#__PURE__*/_react.default.createElement(HeadingBlock, {
    align: "baseline"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    noMargin: true,
    size: breakPoints.sm ? 3 : 1,
    weight: 3,
    text: _services.locale.localeString('Recommendation.AddonSectionTitle')
  }), /*#__PURE__*/_react.default.createElement(InfoText, null, _services.locale.localeString('Recommendation.AddonSectionDisclaimer'))), /*#__PURE__*/_react.default.createElement(PriceBlock, null, /*#__PURE__*/_react.default.createElement(LeftTextStack, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    noMargin: true,
    size: breakPoints.sm ? 3 : 1,
    weight: 3,
    text: name
  })), /*#__PURE__*/_react.default.createElement(RightTextStack, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    noMargin: true,
    size: 3,
    weight: 3,
    text: _services.locale.formatPrice(price)
  }), /*#__PURE__*/_react.default.createElement(RightStackFinePrintAlignmentContainer, null, /*#__PURE__*/_react.default.createElement(InfoText, {
    isBold: true
  }, _services.locale.localeString('Recommendation.AddonSectionUpfrontLabelText')), /*#__PURE__*/_react.default.createElement(InfoText, {
    isBold: true
  }, _services.locale.localeString('Recommendation.AddonSectionUpfrontLabelSubText'))))), /*#__PURE__*/_react.default.createElement(ContentBlock, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, costInfo)), characteristics === null || characteristics === void 0 ? void 0 : characteristics.map((characteristic, index) => {
    return /*#__PURE__*/_react.default.createElement(BulletBlock, {
      align: "center",
      key: index
    }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      group: "system",
      name: characteristic.iconName
    }), /*#__PURE__*/_react.default.createElement(FinePrintBlock, null, characteristic === null || characteristic === void 0 ? void 0 : characteristic.description));
  }));
};
var _default = RecommendationBusinessSolutionAddOn;
exports.default = _default;